<template lang="pug">
  b-row
    .col-xl-12
      panel(:title='$t("title.position_taking_settings")' :bodyClass="'childBody'")
        b-row
          .col-sm-12.col-md-12.col-lg-12.col-xl-12
            #tblModal.table-sm.table-responsive
              .table.table.table-bordered(v-if="$store.getters.getPTSB")
                thead
                  tr
                    th.align-middle.text-nowrap(style="width:10%;") {{ $t("ui.sport_types") }}
                    th.align-middle.text-nowrap(style="width:25%;") {{ $t("ui.types") }}
                    th.align-middle.text-center.text-nowrap(style="width:15%;")
                      small.text-warning {{ $t("ui.copy_to_bottom") }}
                      b-form-checkbox(
                        size="sm"
                        v-model="copyAllUpline"
                        :title="$helpers.copyAllUpline_title()"
                        @input="toggleAll()"
                        plain
                        :disabled="loading"
                      ) {{ uplineName }}
                    th.align-middle.text-center.text-nowrap(style="width:15%;" v-show="isSearch")
                      small.text-warning {{ $t("ui.copy_to_bottom") }}
                      b-form-checkbox(
                        size="sm"
                        v-model="copyAllAccount"
                        :title="$helpers.copyAllAccount_title()"
                        @input="toggleAll()"
                        plain
                        :disabled="loading"
                      ) {{ downlineName }}
                    th.align-middle.text-center.text-nowrap(style="width:15%;" v-show="isSearch")
                      small.text-warning {{ $t("ui.copy_to_bottom") }}
                      b-form-checkbox(
                        size="sm"
                        v-model="copyAllRemaining"
                        :title="$helpers.copyAllRemaining_title()"
                        @input="toggleAll()"
                        plain
                        :disabled="loading"
                      ) {{ $t("ui.remaining") }}
                    th.align-middle.text-center.text-nowrap(style="width:15%;" v-show="isSearch")
                      small.text-warning {{ $t("ui.copy_to_bottom") }}
                      b-form-checkbox(
                        size="sm"
                        v-model="copyAllMin"
                        :title="$helpers.copyAllMin_title()"
                        @input="toggleAll()"
                        plain
                        :disabled="loading"
                      ) {{ $t("ui.min") }}
                ptTableRowSoccer(ref="ptTableRowSoccer" :loading="loading" :upline="copyAllUpline" @clicked="toggleAll" :accountID="accountID")
                ptTableRowParlay(ref="ptTableRowParlay" :loading="loading" :accountID="accountID")
                ptTableRowLiveCasino(v-show="$helpers.isPlatformEnabled('LC')" ref="ptTableRowLiveCasino" :loading="loading" :accountID="accountID")
                ptTableRowSlots(v-show="$helpers.isPlatformEnabled('SL')" ref="ptTableRowSlots" :loading="loading" :accountID="accountID")
                ptTableRowLotto(v-show="$helpers.isPlatformEnabled('LO')" ref="ptTableRowLotto" :loading="loading" :accountID="accountID")
                ptTableRowKeno(v-show="$helpers.isPlatformEnabled('KNno')" ref="ptTableRowKeno" :loading="loading" :accountID="accountID")
                ptTableRowCockfight(v-show="$helpers.isPlatformEnabled('CF')" ref="ptTableRowCockfight" :loading="loading" :accountID="accountID")
                ptTableRowLottery(v-show="$helpers.isPlatformEnabled('LTno')" ref="ptTableRowLottery" :loading="loading" :accountID="accountID")

</template>

<script>
import ptTableRowSoccer from "@/components/positionTaking/ptTableRowSoccer.vue";
import ptTableRowParlay from "@/components/positionTaking/ptTableRowParlay.vue";
import ptTableRowLiveCasino from "@/components/positionTaking/ptTableRowLiveCasino.vue";
import ptTableRowSlots from "@/components/positionTaking/ptTableRowSlots.vue";
import ptTableRowLotto from "@/components/positionTaking/ptTableRowLotto.vue";
import ptTableRowKeno from "@/components/positionTaking/ptTableRowKeno.vue";
import ptTableRowCockfight from "@/components/positionTaking/ptTableRowCockfight.vue";
import ptTableRowLottery from "@/components/positionTaking/ptTableRowLottery.vue";

export default {
  components: {
    ptTableRowSoccer,
    ptTableRowParlay,
    ptTableRowLiveCasino,
    ptTableRowSlots,
    ptTableRowLotto,
    ptTableRowKeno,
    ptTableRowCockfight,
    ptTableRowLottery
  },
  props: {
    loading: false,
    accountID: ""
  },
  data() {
    return {
      copyAllUpline: true,
      copyAllAccount: true,
      copyAllRemaining: true,
      copyAllMin: true
    }
  },
  computed: {
    isSearch: function() {
      if(this.accountID) {
        return !(this.accountID.length > 8)
      } else {
        return !this.$helpers.isAgentLevel()
      }
    },
    uplineName: function() {
      if(this.accountID) {
        switch(this.accountID.length) {
          case 2: //ss
            return this.$helpers.getUplineName(6)
          case 4: //sn
            return this.$helpers.getUplineName(5)
          case 6: //ma
            return this.$helpers.getUplineName(4)
          case 8: //ag
            return this.$helpers.getUplineName(3)
        }
      } else {
        return this.$helpers.getUplineName(this.$store.getters.accountType)
      }
    },
    downlineName: function() {
      if(this.accountID) {
        switch(this.accountID.length) {
          case 2: //ss
            return this.$helpers.getUplineName(5)
          case 4: //sn
            return this.$helpers.getUplineName(4)
          case 6: //ma
            return this.$helpers.getUplineName(3)
          case 8: //ag
            return this.$helpers.getUplineName(2)
        }
      } else {
        return this.$helpers.getUplineName(this.$store.getters.accountType - 1)
      }
    }
  },
  mounted: function() {
    this.$helpers.getPlatform()
    this.$helpers.getPositionTaking()
  },
  methods: {
    setUpline(mode, fromSoccer, lottery) {
      let maxPT = 0
      switch(mode) {
        case "1X2":
          maxPT = this.$refs.ptTableRowSoccer.soccer_1x2_upline_max
          break
        case "OTH":
          maxPT = this.$refs.ptTableRowSoccer.soccer_others_upline_max
          break
        case "HDPMMO":
          maxPT = this.$refs.ptTableRowSoccer.hdp_mmo_upline_max
          break
        case "PL":
          maxPT = this.$refs.ptTableRowParlay.parlay_upline_max
          break
        case "PLMMO":
          maxPT = this.$refs.ptTableRowParlay.parlay_mmo_upline_max
          break
        case "LC":
          maxPT = this.$refs.ptTableRowLiveCasino.livecasino_upline_max
          break
        case "SL":
          maxPT = this.$refs.ptTableRowSlots.slots_upline_max
          break
        case "LO":
          maxPT = this.$refs.ptTableRowLotto.lotto_upline_max
          break
        case "KN":
          maxPT = this.$refs.ptTableRowKeno.keno_upline_max
          break
        case "CF":
          maxPT = this.$refs.ptTableRowCockfight.cockfight_upline_max
          break
        case "LT":
          maxPT = (lottery == 0) ? this.$refs.ptTableRowLottery.lottery_1d_upline_max : this.$refs.ptTableRowLottery.lottery_2d_upline_max
          break
      }

      if (fromSoccer > maxPT) {
        return maxPT
      } else {
        return fromSoccer
      }
    },
    setAccount(mode, fromSoccer, lottery) {
      let maxPT = 0
      let currentPT = 0
      let balance = 0

      switch(mode) {
        case "1X2":
          maxPT = this.$refs.ptTableRowSoccer.soccer_1x2_upline_max
          currentPT = this.$refs.ptTableRowSoccer.soccer_1x2_upline_pt
          break
        case "OTH":
          maxPT = this.$refs.ptTableRowSoccer.soccer_others_upline_max
          currentPT = this.$refs.ptTableRowSoccer.soccer_others_upline_pt
          break
        case "HDPMMO":
          maxPT = this.$refs.ptTableRowSoccer.hdp_mmo_upline_max
          currentPT = this.$refs.ptTableRowSoccer.hdp_mmo_upline_pt
          break
        case "PL":
          maxPT = this.$refs.ptTableRowParlay.parlay_upline_max
          currentPT = this.$refs.ptTableRowParlay.parlay_upline_pt
          break
        case "PLMMO":
          maxPT = this.$refs.ptTableRowParlay.parlay_mmo_upline_max
          currentPT = this.$refs.ptTableRowParlay.parlay_mmo_upline_pt
          break
        case "LC":
          maxPT = this.$refs.ptTableRowLiveCasino.livecasino_upline_max
          currentPT = this.$refs.ptTableRowLiveCasino.livecasino_upline_pt
          break
        case "SL":
          maxPT = this.$refs.ptTableRowSlots.slots_upline_max
          currentPT = this.$refs.ptTableRowSlots.slots_upline_pt
          break
        case "LO":
          maxPT = this.$refs.ptTableRowLotto.lotto_upline_max
          currentPT = this.$refs.ptTableRowLotto.lotto_upline_pt
          break
        case "KN":
          maxPT = this.$refs.ptTableRowKeno.keno_upline_max
          currentPT = this.$refs.ptTableRowKeno.keno_upline_pt
          break
        case "CF":
          maxPT = this.$refs.ptTableRowCockfight.cockfight_upline_max
          currentPT = this.$refs.ptTableRowCockfight.cockfight_upline_pt
          break
        case "LT":
          maxPT = (lottery == 0) ? this.$refs.ptTableRowLottery.lottery_1d_upline_max : this.$refs.ptTableRowLottery.lottery_2d_upline_max
          currentPT = (lottery == 0) ? this.$refs.ptTableRowLottery.lottery_1d_upline_pt : this.$refs.ptTableRowLottery.lottery_2d_upline_pt
          break
      }

      balance = maxPT - currentPT
      if (fromSoccer > balance) {
        return balance
      } else {
        return fromSoccer
      }
    },
    setRemaining(mode, fromSoccer, lottery) {
      let maxPT = 0
      
      switch(mode) {
        case "1X2":
          maxPT = this.$refs.ptTableRowSoccer.soccer_1x2_account_pt
          break
        case "OTH":
          maxPT = this.$refs.ptTableRowSoccer.soccer_others_account_pt
          break
        case "HDPMMO":
          maxPT = this.$refs.ptTableRowSoccer.hdp_mmo_account_pt
          break
        case "PL":
          maxPT = this.$refs.ptTableRowParlay.parlay_account_pt
          break
        case "PLMMO":
          maxPT = this.$refs.ptTableRowParlay.parlay_mmo_account_pt
          break
        case "LC":
          maxPT = this.$refs.ptTableRowLiveCasino.livecasino_account_pt
          break
        case "SL":
          maxPT = this.$refs.ptTableRowSlots.slots_account_pt
          break
        case "LO":
          maxPT = this.$refs.ptTableRowLotto.lotto_account_pt
          break
        case "KN":
          maxPT = this.$refs.ptTableRowKeno.keno_account_pt
          break
        case "CF":
          maxPT = this.$refs.ptTableRowCockfight.cockfight_account_pt
          break
        case "LT":
          maxPT = (lottery == 0) ? this.$refs.ptTableRowLottery.lottery_1d_account_pt : this.$refs.ptTableRowLottery.lottery_2d_account_pt
          break
      }
      if (fromSoccer > maxPT) {
        return maxPT
      } else {
        return fromSoccer
      }
    },
    upline() {
      let soccerHDP = this.$refs.ptTableRowSoccer.soccer_hdp_upline_pt
      this.$refs.ptTableRowSoccer.soccer_1x2_upline_pt = this.setUpline('1X2', soccerHDP)
      this.$refs.ptTableRowSoccer.soccer_others_upline_pt = this.setUpline('OTH', soccerHDP)
      this.$refs.ptTableRowParlay.parlay_upline_pt = this.setUpline('PL', soccerHDP)

      if(['MMK','MMO'].includes(this.$store.getters.getAccountCurrency)) {
        this.$refs.ptTableRowSoccer.hdp_mmo_upline_pt = this.setUpline('HDPMMO', soccerHDP)
        this.$refs.ptTableRowParlay.parlay_mmo_upline_pt = this.setUpline('PLMMO', soccerHDP)
      }

      if((this.$helpers.isPlatformEnabled("LC"))) {
        this.$refs.ptTableRowLiveCasino.livecasino_upline_pt = this.setUpline('LC', soccerHDP)
      }
      if((this.$helpers.isPlatformEnabled("SL"))) {
        this.$refs.ptTableRowSlots.slots_upline_pt = this.setUpline('SL', soccerHDP)
      }
      if((this.$helpers.isPlatformEnabled("LO"))) {
        this.$refs.ptTableRowLotto.lotto_upline_pt = this.setUpline('LO', soccerHDP)
      }
      if((this.$helpers.isPlatformEnabled("KN"))) {
        this.$refs.ptTableRowKeno.keno_upline_pt = this.setUpline('KN', soccerHDP)
      }
      if((this.$helpers.isPlatformEnabled("CF"))) {
        this.$refs.ptTableRowCockfight.cockfight_upline_pt = this.setUpline('CF', soccerHDP)
      }
      if((this.$helpers.isPlatformEnabled("LT"))) {
        this.$refs.ptTableRowLottery.lottery_1d_upline_pt = this.setUpline('LT', soccerHDP, 0)
        this.$refs.ptTableRowLottery.lottery_2d_upline_pt = this.setUpline('LT', soccerHDP, 1)
      }
    },
    account() {
      let soccerHDP = this.$refs.ptTableRowSoccer.soccer_hdp_account_pt
      this.$refs.ptTableRowSoccer.soccer_1x2_account_pt = this.setAccount('1X2', soccerHDP)
      this.$refs.ptTableRowSoccer.soccer_others_account_pt = this.setAccount('OTH', soccerHDP)
      this.$refs.ptTableRowParlay.parlay_account_pt = this.setAccount('PL', soccerHDP)

      if(['MMK','MMO'].includes(this.$store.getters.getAccountCurrency)) {
        this.$refs.ptTableRowSoccer.hdp_mmo_account_pt = this.setAccount('HDPMMO', soccerHDP)
        this.$refs.ptTableRowParlay.parlay_mmo_account_pt = this.setAccount('PLMMO', soccerHDP)
      }

      if((this.$helpers.isPlatformEnabled("LC"))) {
        this.$refs.ptTableRowLiveCasino.livecasino_account_pt = this.setAccount('LC', soccerHDP)
      }
      if((this.$helpers.isPlatformEnabled("SL"))) {
        this.$refs.ptTableRowSlots.slots_account_pt = this.setAccount('SL', soccerHDP)
      }
      if((this.$helpers.isPlatformEnabled("LO"))) {
        this.$refs.ptTableRowLotto.lotto_account_pt = this.setAccount('LO', soccerHDP)
      }
      if((this.$helpers.isPlatformEnabled("KN"))) {
        this.$refs.ptTableRowKeno.keno_account_pt = this.setAccount('KN', soccerHDP)
      }
      if((this.$helpers.isPlatformEnabled("CF"))) {
        this.$refs.ptTableRowCockfight.cockfight_account_pt = this.setAccount('CF', soccerHDP)
      }
      if((this.$helpers.isPlatformEnabled("LT"))) {
        this.$refs.ptTableRowLottery.lottery_1d_account_pt = this.setAccount('LT', soccerHDP, 0)
        this.$refs.ptTableRowLottery.lottery_2d_account_pt = this.setAccount('LT', soccerHDP, 1)
      }
    },
    remaining() {
      let soccerHDP = this.$refs.ptTableRowSoccer.soccer_hdp_upline_remaining
      this.$refs.ptTableRowSoccer.soccer_1x2_upline_remaining = this.setRemaining('1X2', soccerHDP)
      this.$refs.ptTableRowSoccer.soccer_others_upline_remaining = this.setRemaining('OTH', soccerHDP)
      this.$refs.ptTableRowParlay.parlay_upline_remaining = this.setRemaining('PL', soccerHDP)

      if(['MMK','MMO'].includes(this.$store.getters.getAccountCurrency)) {
        this.$refs.ptTableRowSoccer.hdp_mmo_upline_remaining = this.setRemaining('HDPMMO', soccerHDP)
        this.$refs.ptTableRowParlay.parlay_mmo_upline_remaining = this.setRemaining('PLMMO', soccerHDP)
      }

      if((this.$helpers.isPlatformEnabled("LC"))) {
        this.$refs.ptTableRowLiveCasino.livecasino_upline_remaining = this.setRemaining('LC', soccerHDP)
      }
      if((this.$helpers.isPlatformEnabled("SL"))) {
        this.$refs.ptTableRowSlots.slots_upline_remaining = this.setRemaining('SL', soccerHDP)
      }
      if((this.$helpers.isPlatformEnabled("LO"))) {
        this.$refs.ptTableRowLotto.lotto_upline_remaining = this.setRemaining('LO', soccerHDP)
      }
      if((this.$helpers.isPlatformEnabled("KN"))) {
        this.$refs.ptTableRowKeno.keno_upline_remaining = this.setRemaining('KN', soccerHDP)
      }
      if((this.$helpers.isPlatformEnabled("CF"))) {
        this.$refs.ptTableRowCockfight.cockfight_upline_remaining = this.setRemaining('CF', soccerHDP)
      }
      if((this.$helpers.isPlatformEnabled("LT"))) {
        this.$refs.ptTableRowLottery.lottery_1d_upline_remaining = this.setRemaining('LT', soccerHDP, 0)
        this.$refs.ptTableRowLottery.lottery_2d_upline_remaining = this.setRemaining('LT', soccerHDP, 1)
      }
    },
    min() {
      let soccerHDP = this.$refs.ptTableRowSoccer.soccer_hdp_account_min
      this.$refs.ptTableRowSoccer.soccer_1x2_account_min = this.setRemaining('1X2', soccerHDP)
      this.$refs.ptTableRowSoccer.soccer_others_account_min = this.setRemaining('OTH', soccerHDP)
      this.$refs.ptTableRowParlay.parlay_account_min = this.setRemaining('PL', soccerHDP)

      if(['MMK','MMO'].includes(this.$store.getters.getAccountCurrency)) {
        this.$refs.ptTableRowSoccer.hdp_mmo_account_min = this.setRemaining('HDPMMO', soccerHDP)
        this.$refs.ptTableRowParlay.parlay_mmo_account_min = this.setRemaining('PLMMO', soccerHDP)
      }

      if((this.$helpers.isPlatformEnabled("LC"))) {
        this.$refs.ptTableRowLiveCasino.livecasino_account_min = this.setRemaining('LC', soccerHDP)
      }
      if((this.$helpers.isPlatformEnabled("SL"))) {
        this.$refs.ptTableRowSlots.slots_account_min = this.setRemaining('SL', soccerHDP)
      }
      if((this.$helpers.isPlatformEnabled("LO"))) {
        this.$refs.ptTableRowLotto.lotto_account_min = this.setRemaining('LO', soccerHDP)
      }
      if((this.$helpers.isPlatformEnabled("KN"))) {
        this.$refs.ptTableRowKeno.keno_account_min = this.setRemaining('KN', soccerHDP)
      }
      if((this.$helpers.isPlatformEnabled("CF"))) {
        this.$refs.ptTableRowCockfight.cockfight_account_min = this.setRemaining('CF', soccerHDP)
      }
      if((this.$helpers.isPlatformEnabled("LT"))) {
        this.$refs.ptTableRowLottery.lottery_1d_account_min = this.setRemaining('LT', soccerHDP, 0)
        this.$refs.ptTableRowLottery.lottery_2d_account_min = this.setRemaining('LT', soccerHDP, 1)
      }
    },
    toggleAll: function() {
      if(this.copyAllUpline) {
        this.upline()
      }

      if(this.copyAllAccount) {
        this.account()
      }

      if(this.copyAllRemaining) {
        // if(this.copyAllAccount) {
          this.remaining()
        // }
      }

      if(this.copyAllMin) {
        // if(this.copyAllAccount) {
          this.min()
        // }
      }
    }
  }
}
</script>